export default __webpack_public_path__ + "static/media/Modelo 4.8ac29574.png";